<script setup lang="ts">
import type { MenuItem } from 'primevue/menuitem';

const props = defineProps< { item: MenuItem }>();
</script>

<template>
  <div class="flex items-center w-full gap-2 px-3 py-1">
    <template v-if="props.item.image">
      <img :src="props.item.image" class="size-5 bg-white/25 rounded">
    </template>
    <template v-else-if="props.item.icon">
      <i :class="'p-menu-item-icon pi ' + props.item.icon"></i>
    </template>
    <div>{{ props.item.label }}</div>
  </div>
</template>